import { atom } from "jotai";

export const fileAtom = atom("");
